module.exports = __webpack_public_path__ + "static/media/logo_sk.caaefaee.svg";